<script lang="ts" setup>
import { initFlowbite } from 'flowbite'
import { onMounted } from 'vue'

import CanonicalLink from '@/components/CanonicalLink/CanonicalLink.vue'
import CompliancePopup from '@/components/CompliancePopup.vue'
import BrazilGeoIpStickyNotice from '@/components/BrazilGeoIpStickyNotice.vue'
import LiveChat from '@/components/LiveChat/LiveChat.vue'
import { useHreflang } from '@/hooks/useHreflangs'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { useGlobalSeoStore } from '@/stores/globalSeo'

import BrazilRegulationsPopup from './components/BrazilRegulationsPopup.vue'
import RiskWarningPopUp from './components/RiskWarningPopUp.vue'

onMounted(() => {
  initFlowbite()
  useHreflang()
  useGlobalSeoStore().fetchAllGlobalSeo()
  // useGlobalSeoMetaHandler(true)
})
</script>

<template>
  <CompliancePopup></CompliancePopup>
  <RiskWarningPopUp></RiskWarningPopUp>
  <BrazilRegulationsPopup></BrazilRegulationsPopup>
  <CanonicalLink />
  <component :is="$route.meta.layout || DefaultLayout">
    <router-view />
  </component>
  <BrazilGeoIpStickyNotice />
  <LiveChat></LiveChat>
</template>
